import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'UkkoPlusIcon'
},
  __name: 'UkkoPlusIcon',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: require('@/assets/images/features/ukko_plus.svg'),
    alt: "Ukko Plus logo"
  }, null, 8, _hoisted_1))
}
}

})